import { render, staticRenderFns } from "./More.vue?vue&type=template&id=1a05c3cb&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a05c3cb')) {
      api.createRecord('1a05c3cb', component.options)
    } else {
      api.reload('1a05c3cb', component.options)
    }
    module.hot.accept("./More.vue?vue&type=template&id=1a05c3cb&", function () {
      api.rerender('1a05c3cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/More/More.vue"
export default component.exports